import React, { useState, useEffect } from 'react'
import AddIcon from '@material-ui/icons/Add'
import { Link, withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import { sortBy } from 'lodash'
import CitiesIcon from 'Assets/Images/icons/cities'
import GridIcon from 'Assets/Images/icons/grid'
import ListIcon from 'Assets/Images/icons/list'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { Breadcrumb } from 'react-breadcrumbs'
import { PATHS } from 'Config/Routing/paths'
import { PageTitle } from 'Components/PageTitle'
import { FilterSelect } from 'Components/Filter/FilterSelect'
import { CitiesWrapper } from 'Components/City'
import { FiltersWrapper } from 'Components/Filter/FiltersWrapper'
import { FilterButton } from 'Components/Filter/FilterButton'
import { FilterBox } from 'Components/Filter/FiltersWrapper/box'
import { CardsList } from 'Components/CardsList'
import { Col } from 'react-bootstrap'
import { CityCard } from 'Components/City/Card'

import { getCities, setFilterCountry } from 'Reducers/City/actions'
import { CITY_FILTER_STATUS } from 'Reducers/City/const'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import classNames from 'classnames'
import StyledIconButton from '../../../Components/Form/StyledIconButton'
import { authorization } from 'Module/Auth/Auth'

const CityList = props => {
  const [state, setState] = useState({
    listView: 'grid',
    statusFilter: CITY_FILTER_STATUS.ACTIVE,
  })
  const dispatch = useDispatch()

  let citiesList = useSelector(state => sortBy(state.city.citiesList, 'name'))
  let filterCountry = useSelector(state => state.city.filterCountry)
  let countryList = useSelector(state =>
    reducerCountryList(state.city.citiesList),
  )
  useEffect(() => {
    let user = authorization.getUser()
    dispatch(setFilterCountry(user.countryCode))
    const includeInactiveCities = true
    dispatch(getCities(includeInactiveCities))
  }, [])

  const statuses = [
    { value: CITY_FILTER_STATUS.ALL, label: 'All' },
    { value: CITY_FILTER_STATUS.ACTIVE, label: 'Active' },
    { value: CITY_FILTER_STATUS.ARCHIVE, label: 'Archived' },
  ]
  /**
   * Render list of cities
   *
   * @returns JSX.Element[] | null
   */
  const renderCities = () => {
    let { history, match } = props

    if (citiesList.length) {
      citiesList = filterCitiesByCountry(citiesList)
      citiesList = filterCitiesByStatus(citiesList)

      return citiesList.map((city, idx) => (
        <Col key={idx} xs={3}>
          <CityCard
            id={`city-card-${city.name}`}
            city={city}
            editPath={`${match.url}/${city.id}/edit`}
            tileClickHandler={() => {
              history.push(`${match.url}/${city.id}/global-planning`)
            }}
            viewPath={`${match.url}/${city.id}/global-planning`}
          />
        </Col>
      ))
    }

    return null
  }

  /**
   * Filter cities by country code
   *
   * @param {Array} cities
   * @returns {Array}
   */
  const filterCitiesByCountry = cities => {
    if (filterCountry) {
      return cities.filter(city => {
        return city.country.code === filterCountry
      })
    }

    return cities
  }

  /**
   * Filter cities by status
   *
   * @param {Array} cities
   * @returns {Array}
   */
  const filterCitiesByStatus = cities => {
    const { statusFilter } = state

    if (statusFilter) {
      return cities.filter(city => {
        return city.statusV2 === statusFilter.toUpperCase()
      })
    }

    return cities
  }

  /**
   * Change filter country
   *
   * @param e
   * @param index
   * @param value
   */
  const onChangeFilterCountry = (e, index, value) => {
    dispatch(setFilterCountry(value))
  }
  const onChangeFilterStatus = (e, index, value) => {
    setState({ statusFilter: value })
  }
  return (
    <LayoutDashboard>
      <HideWhenBlocked>
        <CitiesWrapper>
          <Breadcrumbs icon={<CitiesIcon style={{ width: 24 }} />} />
          <Breadcrumb
            data={{ title: 'Cities', pathname: PATHS.dashboard.cities }}
          />
          <PageTitle>
            Cities{' '}
            <Link
              style={{ display: 'flex', justifyContent: 'flex-end' }}
              to={props.match.url + PATHS.cities.add}
            >
              <StyledIconButton>
                <AddIcon />
              </StyledIconButton>
            </Link>
          </PageTitle>
          <FiltersWrapper>
            <FilterBox className="filter-box">
              <FilterSelect
                className="country-selector"
                label="Status"
                options={statuses}
                value={state.statusFilter}
                onChange={onChangeFilterStatus}
                sorted={true}
              />
            </FilterBox>

            <FilterBox className="filter-box align-right">
              <FilterSelect
                className="country-selector"
                label="Country"
                options={countryList}
                value={filterCountry}
                onChange={onChangeFilterCountry}
                sorted={true}
              />

              <FilterBox>
                <FilterButton
                  className={state.listView === 'grid' ? 'active' : ''}
                  onClick={() => {
                    setState({ listView: 'grid' })
                  }}
                >
                  <GridIcon />
                </FilterButton>

                <FilterButton
                  className={state.listView === 'list' ? 'active' : ''}
                  onClick={() => {
                    setState({ listView: 'list' })
                  }}
                >
                  <ListIcon />
                </FilterButton>
              </FilterBox>
            </FilterBox>
          </FiltersWrapper>
          {/*TODO Populate CityCard with real data*/}

          <CardsList
            className={classNames(
              state.listView === 'list' && 'as-list',
              'cities',
            )}
          >
            {renderCities()}
          </CardsList>
        </CitiesWrapper>
      </HideWhenBlocked>
    </LayoutDashboard>
  )
}

const reducerCountryList = cities => {
  const initial = { all: { value: null, label: 'ALL' } }
  const countryMap = cities.reduce((agg, city) => {
    const country = city.country

    if (country && !agg[country.code]) {
      agg[country.code] = { value: country.code, label: country.name }
    }
    return agg
  }, initial)

  return Object.values(countryMap)
}

export default withRouter(CityList)



// WEBPACK FOOTER //
// ./src/Containers/City/List/index.js